import Fetch from "utils/fetch";

export interface ServiceResponse {
  AllSuccess: boolean;
  Results: ResultItem[];
}

export interface ResultItem {
  Type: number;
  Message: string;
}

export const downloadDoiInventoryPolicy = (): Promise<string> => {
  return Fetch.get(`dynamic-inventory-policies:doi-export`).then(({ data }) => data);
};

export const updateDoiInventoryPolicyJson = (policyData: any): Promise<ServiceResponse> => {
  return Fetch.put(`dynamic-inventory-policies:doi-import`, policyData).then(({ data }) => data);
};

export const downloadDoiInventoryPolicyTemplate = (): Promise<string> => {
  return Fetch.get(`dynamic-inventory-policies:doi-export-template`).then(({ data }) => data);
};
